import script from "./collapsible-section.vue?vue&type=script&setup=true&lang=js"
export * from "./collapsible-section.vue?vue&type=script&setup=true&lang=js"

import "./collapsible-section.vue?vue&type=style&index=0&id=801f8a28&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-801f8a28"]])

export default __exports__